module.exports = __webpack_public_path__ + "ae86c041245e92a4362d1a3bbd5c4ea3.svg";